import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import FileSaver from "file-saver";

const DownloadInitialScheduleTerm = ({ item, dealerId, downloadAction }) => {
  const itemId = item.id;

  return (
    <ModalBuilder
      submitAction={downloadAction}
      submitParams={{ id: itemId, dealerId }}
      onSubmitted={(result) => {
        result && FileSaver.saveAs(result, `${item.boilerPlateCode}.docx`);
      }}
      renderTrigger={(showModal) => (
        <Button
          primary
          onClick={showModal}
          title="Download"
          icon="download"
          className="download-btn"
        />
      )}
      renderModal={(modalProps) => (
        <Modal.Confirmation {...modalProps} header="Download File">
          Are you sure you want to download?
        </Modal.Confirmation>
      )}
    />
  );
};

export default DownloadInitialScheduleTerm;
